module.exports = __webpack_public_path__ + "static/media/E16.25df9d9a.jpg";